import dayjs from 'dayjs';
import { useState } from 'react';

import { CheckoutType } from 'types';
import { List } from 'components/list';
import { Flex } from 'components/flex';
import { mapQuery } from 'utils/query';
import { formatDate } from 'utils/date';
import { useSearchPagination } from 'hooks';
import { ListCard } from 'components/list-card';
import { EventCheckout } from 'store/api/event';
import { ListHeader } from 'components/list-header';
import { useCheckoutsQuery } from 'store/api/customers';
import { formatPrice, joinStrings } from 'utils/helpers';
import { CheckoutLabels } from 'components/checkout-labels';
import { SaleDetailsDrawer } from 'components/sale-details-drawer';

import * as Styles from './styles';
import { CheckoutsProps } from './types';

const getFormattedAmount = (amount?: number) => amount && formatPrice(amount);
const template = '64px 120px repeat(8, 1fr)';
const titles = [
  'Invoice#',
  'Date',
  'Event',
  'Labels',
  'Employee',
  'Sub Total',
  'Tax',
  'Tip',
  'Processing Fee',
  'Total',
];

export const Checkouts = ({ id }: CheckoutsProps) => {
  const pageData = useSearchPagination();
  const { currentPage: page, debounceQuery: search } = pageData;

  const [selectedCheckout, setSelectedCheckout] = useState<EventCheckout>();
  const { data, ...props } = useCheckoutsQuery(
    { page, search, id: Number(id) },
    { skip: !id }
  );

  return (
    <>
      <Flex column>
        <Styles.Title>Checkouts</Styles.Title>
        <List
          {...pageData}
          {...mapQuery(props)}
          count={data?.count}
          header={<ListHeader titles={titles} template={template} />}
        >
          {data?.rows?.map((value) => {
            const isExchange = value?.type === CheckoutType.Exchange;
            const isShowLabels =
              isExchange ||
              value?.isVoided ||
              !!value?.shippingPrice ||
              !!value?.refund?.length;

            const dateByEventTimezone = dayjs(value?.createdAt).tz(
              value?.event?.timezone?.code
            );

            return (
              <ListCard
                key={value.id}
                headers={titles}
                template={template}
                onClick={() => setSelectedCheckout(value)}
                values={[
                  value?.id,
                  <Flex flexDirection="column">
                    <p>{formatDate(dateByEventTimezone)}</p>
                    <p>{formatDate(dateByEventTimezone, 'LT')}</p>
                  </Flex>,
                  value?.event?.name,
                  isShowLabels ? (
                    <CheckoutLabels column checkout={value} />
                  ) : null,
                  joinStrings(
                    value?.commissions?.map(
                      (commission) => commission?.user?.name
                    ) || [],
                    ', '
                  ),
                  getFormattedAmount(value?.subTotal),
                  getFormattedAmount(value?.taxAmount),
                  getFormattedAmount(value?.tip),
                  getFormattedAmount(value?.processingFeesAmount),
                  getFormattedAmount(value?.saleTotal),
                ]}
              />
            );
          })}
        </List>
      </Flex>

      <SaleDetailsDrawer
        selectedReceipt={selectedCheckout}
        setSelectedReceipt={setSelectedCheckout}
      />
    </>
  );
};
